import { CreateFieldMeasurementDTO } from '../api/api';
import WorkClient from '../api/workClient';

const getMeasurements = (assetId: string) => {
  return WorkClient.fieldMeasurementAll(assetId);
};

const createFieldMeasurement = (fieldMeasurement: CreateFieldMeasurementDTO) => {
  return WorkClient.fieldMeasurement(fieldMeasurement);
};

const FieldMeasurementService = {
  getMeasurements, createFieldMeasurement
};

export default FieldMeasurementService;
